import { useContext } from 'react';
import { AuthContext } from '~/contexts/Auth';

export type ApplicationData = {
  applicationId: string;
};

export const useGetApplicationData = (): ApplicationData => {
  const { auth } = useContext(AuthContext);

  return { applicationId: auth.user.applicationId };
};
